import React from 'react';
import classNames from 'classnames';
import { next, previous, ellipses } from '../../../constants/pagination';
const range = (start, end) => new Array(end > 0 ? end - start : 0)
    .fill(start)
    .map((value, idx) => value + idx);
export function getPaginationNumbers(nPages, currentPageNumber) {
    const hasNextAndPrev = nPages > 7;
    const low = Math.max(1, Math.min(currentPageNumber - 3, nPages - 6));
    const high = Math.min(nPages, low + 6) + 1;
    // always create 7 items when there are 7 or more pages
    const numbers = range(low, high);
    if (hasNextAndPrev) {
        // add previous arrows when beginning pages are not visible
        if (currentPageNumber > 4) {
            numbers.splice(0, 2, previous, ellipses);
        }
        // add next arrows when end pages are not visible
        if (currentPageNumber < nPages - 3) {
            numbers.splice(numbers.length - 2, 2, ellipses, next);
        }
        // show last page on first pagination
        if (currentPageNumber === 1) {
            numbers.splice(numbers.length - 3, 2, ellipses, nPages);
        }
    }
    return numbers;
}
function getCurrentClass(page, n) {
    return page === n ? ' hd-pagination__current sui-bg-brand' : '';
}
const paginationItemClassName = 'hd-pagination__item';
export function Pagination({ className, nPages, onChangePage, page, }) {
    const items = getPaginationNumbers(nPages, page).map((n, index) => {
        switch (n) {
            case previous:
                return (React.createElement("li", { key: n, className: `${paginationItemClassName} hd-pagination__button` },
                    React.createElement("button", { type: "button", onClick: () => onChangePage(page - 1), className: "hd-pagination__link" }, "Prev")));
            case next:
                return (React.createElement("li", { key: n, className: `${paginationItemClassName} hd-pagination__button` },
                    React.createElement("button", { type: "button", onClick: () => onChangePage(page + 1), className: "hd-pagination__link" }, "Next")));
            case ellipses:
                return (React.createElement("li", { key: 'ellipses-' + index, className: paginationItemClassName },
                    React.createElement("span", { className: "hd-pagination__spacer sui-leading-[normal]" }, n)));
            default:
                return (React.createElement("li", { key: n, className: paginationItemClassName },
                    React.createElement("button", { "data-testid": "pagination-button-number", type: "button", onClick: () => onChangePage(+n), className: `hd-pagination__link ${getCurrentClass(page, Number(n))}` }, n)));
        }
    });
    return (React.createElement("div", { className: "container" },
        React.createElement("nav", { className: classNames('hd-pagination', className), role: "navigation" },
            React.createElement("ul", { className: "hd-pagination__wrapper" }, items))));
}
